import { appContext } from '../../service/AppContext';
import { formatNumber, getPersonIdValidation } from '../../service/inputUtil';
import Input from '../input/Input'
import { useContext, useEffect, useRef, useState, } from 'react'


export default function LeadForm() {

    const { setFetch, user, setUser, navigate, isPending, urlAgent } = useContext(appContext)

    const [donorIdValidation, setDonorIdValidation] = useState({ invalid: false, errorText: '' })

    // Which button was used to submit: false -> simulator (default), true -> jump to family plan
    const goFamily = useRef(false)

    const handleSubmit = (e) => {
        e.preventDefault();

        const formElement = e.target;
        const isValid = formElement.checkValidity() && !donorIdValidation.invalid;
        formElement.classList.add('submitted');

        if (isValid) {
            const dataObject = new FormData(formElement);
            if (Object.values(urlAgent).some(v => v))
                dataObject.set('urlAgent', JSON.stringify(urlAgent))
            setFetch({ route: '/lead', options: { method: 'POST', body: dataObject } })
            // navigate('/simulator', { state: { user } })
        }
        else {
            const firstInvalidField = formElement.querySelector(":invalid");
            if (firstInvalidField)
                firstInvalidField?.focus();
            else if (donorIdValidation?.invalid)
                formElement.querySelector('#person-id').focus()
        }
    }

    useEffect(() => {
        if (user?.id) {
            if (goFamily.current)
                navigate('/registration', { state: { user, urlAgent, planMode: 'family', familySubMode: 'preBorn' } })
            else
                navigate('/simulator', { state: { user, urlAgent } })
        }
    }, [user, navigate, urlAgent])

    const HandleUpdateUserCB = (key) => {
        if (key === 'mobile') return updateUserPhone
        if (key === 'personId') return updateUserId
        return updateUserKey
        function updateUserKey(value) {
            setUser(prev => { return { ...prev, [key]: value } })
        }
        function updateUserPhone(value) {
            value = formatNumber(value, { allowDesh: true });
            updateUserKey(value);
        }
        function updateUserId(value) {
            value = formatNumber(value);
            if (value.length === 0)
                setDonorIdValidation({ invalid: false, errorText: '' })
            else setDonorIdValidation(getPersonIdValidation(value))
            updateUserKey(value);
        }
    }

    return (
        <div className="card-content-wrapper">
            <h3 >מלאו את הפרטים האישיים שלכם</h3>
            <form className={"client-info"} onSubmit={handleSubmit} noValidate>
                <div className="fields-grid-wrapper">
                    <div className="fields-grid2">
                        <Input value={user.lastName} onChange={HandleUpdateUserCB('lastName')} type='text' name='last-name' id='last-name' label='שם משפחה' required />
                        <Input value={user.firstName} onChange={HandleUpdateUserCB('firstName')} type='text' name='first-name' id='first-name' label='שם פרטי' required />
                    </div>
                    <Input value={user.mobile} onChange={HandleUpdateUserCB('mobile')} type='tel' name='mobile' id='mobile' label='טלפון' required pattern="[0-9]{2,3}-?[0-9]{7}" maxlength={/-/.test(user?.mobile) ? 11 : 10} />
                    <Input value={user.email} onChange={HandleUpdateUserCB('email')} type='email' name='mail' id='mail' label='כתובת דוא"ל' required pattern="\w+(.+\w+)?@\w+(\.\w+)+" />
                    <Input value={user.personId} onChange={HandleUpdateUserCB('personId')} type='text' name='person-id' id='person-id' label='מספר תעודת זהות (אופציונלי)' maxlength={9} invalid={donorIdValidation?.invalid} errorText={donorIdValidation?.errorText} />
                </div>
                <div className="comma-notes">* שדות חובה</div>
                <div className="lead-form-buttons">
                    <button type="submit" className="button" disabled={isPending} onClick={() => goFamily.current = false}>המשך</button>
                    <button type="submit" className="button white-button" disabled={isPending} onClick={() => goFamily.current = true}>מעבר לתוכנית המשפחתית</button>
                </div>
            </form>
        </div>)
}

